import { AppLauncher } from '@capacitor/app-launcher';
import { Injectable } from '@angular/core';
import { LoadingController, Platform } from '@ionic/angular';
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  constructor(
    private platform: Platform,
    public loadingCtrl: LoadingController,
    private previewAnyFile: PreviewAnyFile,
  ) { }

  openLink(link: string) {
    if (!link) {
      return;
    }
    // App nativo: abre no navegador do sistema (era o '_system' do
    // cordova-plugin-inappbrowser, removido por vulnerabilidade crítica no iOS).
    if (this.platform.is('capacitor')) {
      AppLauncher.openUrl({ url: link }).catch(() => this.openBrowserLink(link));
    }
    //BROWSER
    else {
      this.openBrowserLink(link);
    }
  }

  openPDF(url: string) {
    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      this.openNativePDF(url);
    } else {
      this.openBrowserPDF(url);
    }
  }

  private openBrowserLink(url: string) {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private openBrowserPDF(url: string) {
    const link = document.createElement('a');
    link.target = '_blank';
    link.href = url;
    link.setAttribute('visibility', 'hidden');
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private async openNativePDF(url: string) {
    const loading = await this.loadingCtrl.create({});
    loading.present();
    this.previewAnyFile
      .previewPath(url, {
        mimeType: 'application/pdf'
      }).subscribe({
        next: (res) => {
          loading.dismiss();
        },
        error: (error) => {
          loading.dismiss();
          console.error('Error: ', error);
        }
      });
  }
}
